import { PaymentTerm } from '../models/payment-term.model';

export class PaymentTermMapper {
  public mapPaymentTermRequest(data: PaymentTerm) {
    const request = {
      UId: data.uId,
      Name: data.name,
      PaymentKindType: data.paymentKindType,
      PaymentDate: data.paymentDate,
      DiscountReferenceType: data.discountReferenceType,
      FirstDiscountPeriod: data.firstDiscountPeriod,
      FirstDiscountRate: data.firstDiscountRate,
      SecondDiscountPeriod: data.secondDiscountPeriod,
      SecondDiscountRate: data.secondDiscountRate,
      InfoDesc: data.infoDesc,
      BodyText: data.bodyText,
    };

    return request;
  }
}
